// extracted by mini-css-extract-plugin
module.exports = {"scrollbody":"addCollege_scrollbody__4kdEB"};